module.exports = __webpack_public_path__ + "img/usp_icon4.bca72eec.svg";